import React, { Fragment, useEffect, useState } from "react";
import GlonasControl from "../../../../shared/GlonasControl/GlonasControl";
import GpsCoordinatesControl from "../../../../shared/GpsCoordinatesControl/GpsCoordinatesControl";
import {SynchronizationApi} from "../../../../../services/Synchronization.api";
import {StoredGpsData, SynchronizationGpsControlProps} from "./Synchronization.model";

const SynchronizationGpsControl = ({
  executeCommand,
  clockStationId,
  onCurrentCoordinatesChange,
  onStoredCoordinatesChange
}: SynchronizationGpsControlProps) => {
  const [loading, setLoading] = useState(false);
  const [storedGpsData, setStoredGpsData] = useState<StoredGpsData | null>(null);

  useEffect(() => {
    readSavedGpsData();
  }, [clockStationId]);

  useEffect(() => {
    if (!storedGpsData?.hasData) {
      onStoredCoordinatesChange?.(null);
      return;
    }

    const coordinates = `${storedGpsData.latitudeDirection} ${storedGpsData.latitude} ${storedGpsData.longitudeDirection} ${storedGpsData.longitude}`;
    onStoredCoordinatesChange?.(coordinates);
  }, [storedGpsData, onStoredCoordinatesChange]);

  const readSavedGpsData = async () => {
    setLoading(true);
    try {
      const response = await SynchronizationApi.getGpsData(clockStationId);

      setStoredGpsData(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const renderStoredGpsData = (data: StoredGpsData) => {
    if (!data.hasData) {
      return (
        <p>Нет сохраненных координат</p>
      );
    }

    return (
      <GpsCoordinatesControl
        longitudeDirection={data.longitudeDirection as "E" | "W"}
        longitude={data.longitude ?? ""}
        latitudeDirection={data.latitudeDirection as "N" | "S"}
        latitude={data.latitude ?? ""}
      />
    );
  };

  return (
    <Fragment>
      <fieldset disabled={loading}>
        <div className="row">
          <GlonasControl
            clockStationId={clockStationId}
            executeCommand={executeCommand as any}
            onCoordinatesChange={onCurrentCoordinatesChange}
          />
        </div>
        <div className="row">
          <div className="col">
            <p>Сохраненные координаты</p>
          </div>
        </div>
        <div className="row">
          <div className="col">
            {storedGpsData && renderStoredGpsData(storedGpsData)}
          </div>
        </div>
      </fieldset>
    </Fragment>
  );
};

export default SynchronizationGpsControl;
